import React from 'react';
import styled from 'styled-components';

// ICONS
import { FaWhatsapp } from 'react-icons/fa';

const WhatsappButtonContainer = styled.a`
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 60px;
  height: 60px;
  background-color: #25D366;
  color: white;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 28px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  z-index: 999;
  
  &:hover {
    transform: scale(1.1);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
  }
  
  @media screen and (max-width: 768px) {
    width: 50px;
    height: 50px;
    font-size: 24px;
    bottom: 20px;
    right: 20px;
  }
`;

const WhatsappButton = () => {
  return (
    <WhatsappButtonContainer 
      href="https://wa.me/551632036800?text=Olá,%20gostaria%20de%20saber%20mais%20sobre%20o%20SofChef!" 
      target="_blank" 
      rel="noopener noreferrer"
      aria-label="Conversar pelo WhatsApp"
    >
      <FaWhatsapp />
    </WhatsappButtonContainer>
  );
};

export default WhatsappButton;
